/* eslint-disable */
// ---------------------------------------------------------------------------
// GENEROVANÝ SOUBOR — needituj ručně.
// Vzniká z adresářů v packages/games/src/ příkazem `npm run games:sync`.
// ---------------------------------------------------------------------------
import { lazy } from 'react'

import type { GameComponent, GameManifest } from './types.ts'
import { manifest as motSpheresManifest } from './mot-spheres/manifest.ts'

/** Manifesty všech registrovaných her, seřazené podle názvu adresáře. */
export const manifests: readonly GameManifest[] = [
  motSpheresManifest,
]

/**
 * Komponenty her. Načítají se líně, takže Three.js a herní kód
 * stáhne prohlížeč až ve chvíli, kdy klient trénink opravdu spustí.
 */
export const components: Record<string, GameComponent> = {
  'mot-spheres': lazy(() => import('./mot-spheres/Game.tsx')),
}
